/**
 * Critical JavaScript - Loads first on every page
 * Initializes cart state and runs template-specific scripts
 */

import { updateCartBubble } from './utilities-test.js';
import { runTemplateScripts } from './template-router.js';

document.addEventListener('DOMContentLoaded', () => {
  updateCartBubble();

  const template = window.Theme?.template?.name;
  if (template) {
    runTemplateScripts(template);
  }
});

// Ensure this also runs after transitions if needed
window.runTemplateScripts = runTemplateScripts;

// Sitewide details script to ensure no overlap with other same page details containers



